export default (editor, opts = {}) => {
  const domc = editor.DomComponents;
  
  const heading_style = {
    'h1': 'mb-4 text-5xl font-extrabold',
    'h2': 'mb-4 text-4xl font-bold',
    'h3': 'mb-4 text-3xl font-bold',
    'h4': 'mb-4 text-2xl font-bold',
    'h5': 'mb-4 text-xl font-bold',
    'h6': 'mb-4 text-lg font-bold'
  }
  domc.addType('HEADING', {
    model: {
      defaults: {
        tagName: 'h1',
        components: '<span>Insert your text here</span>',
        traits: [
          {
            type: "select",
            name: "heading",
            label: "Heading",
            changeProp: 1,
            options: [
              { id: 'h1', name: 'H1'},
              { id: 'h2', name: 'H2'},
              { id: 'h3', name: 'H3'},
              { id: 'h4', name: 'H4'},
              { id: 'h5', name: 'H5'},
              { id: 'h6', name: 'H6'},
            ]
          }
        ]
      },
      init() {
        this.on("change:heading", this.handleHeadingTagChange);
        this.updateHeadingStyles(); // Initial update
      },
      handleHeadingTagChange() {
        this.attributes.tagName = this.attributes.heading
        this.updateHeadingStyles();
        this.view.render();
      },
      updateHeadingStyles() {
        const identifier_class = (Math.random() + 1).toString(36).substring(2);
        this.setClass(heading_style[this.attributes.tagName] + ' techtown_' + identifier_class);
      }
    },
    view: {
      
    },
  });

  domc.addType('PARTICLES', {
    model: {
      defaults: {
        tagName: 'div',
        components: ''
      },
    },
    view: {
      
    },
  });
  domc.addType('SECTION', {
    model: {
      defaults: {
        tagName: 'section',
        components: '<div class="container px-5 py-24 mx-auto"><div class="grid grid-cols-3 gap-3"><div class="p-4"><div class="h-full bg-gray-100 bg-opacity-75 px-8 pt-16 pb-24 rounded-lg overflow-hidden text-center relative"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3">Raclette Blueberry Nextious Level</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><div class="text-center mt-2 leading-none flex justify-center absolute bottom-0 left-0 w-full py-4"><span class="text-gray-400 mr-3 inline-flex items-center leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div><div class="p-4"><div class="h-full bg-gray-100 bg-opacity-75 px-8 pt-16 pb-24 rounded-lg overflow-hidden text-center relative"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3">Ennui Snackwave Thundercats</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><div class="text-center mt-2 leading-none flex justify-center absolute bottom-0 left-0 w-full py-4"><span class="text-gray-400 mr-3 inline-flex items-center leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div><div class="p-4"><div class="h-full bg-gray-100 bg-opacity-75 px-8 pt-16 pb-24 rounded-lg overflow-hidden text-center relative"><h2 class="tracking-widest text-xs title-font font-medium text-gray-400 mb-1">CATEGORY</h2><h1 class="title-font sm:text-2xl text-xl font-medium text-gray-900 mb-3">Selvage Poke Waistcoat Godard</h1><p class="leading-relaxed mb-3">Photo booth fam kinfolk cold-pressed sriracha leggings jianbing microdosing tousled waistcoat.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg class="w-4 h-4 ml-2" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5l7 7-7 7"></path></svg></a><div class="text-center mt-2 leading-none flex justify-center absolute bottom-0 left-0 w-full py-4"><span class="text-gray-400 mr-3 inline-flex items-center leading-none text-sm pr-3 py-1 border-r-2 border-gray-200"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>1.2K</span><span class="text-gray-400 inline-flex items-center leading-none text-sm"><svg class="w-4 h-4 mr-1" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z"></path></svg>6</span></div></div></div></div></div>',
        // traits: [
        //   {
        //     type: "select",
        //     name: "heading",
        //     label: "Heading",
        //     changeProp: 1,
        //     options: [
        //       { id: 'h1', name: 'H1'},
        //       { id: 'h2', name: 'H2'},
        //       { id: 'h3', name: 'H3'},
        //       { id: 'h4', name: 'H4'},
        //       { id: 'h5', name: 'H5'},
        //       { id: 'h6', name: 'H6'},
        //     ]
        //   },
        // ]
      },
      init() {
        // this.on("change:heading", this.handleHeadingTagChange);
        this.updateSectionStyles(); // Initial update
        
      },
      handleHeadingTagChange() {
        // this.attributes.tagName = this.attributes.heading
        // this.updateHeadingStyles();
        // this.view.render(); // Trigger re-render
      },
      updateSectionStyles() {
        // const identifier_class = (Math.random() + 1).toString(36).substring(2);
        // this.setClass(heading_style[this.attributes.tagName] + ' techtown_' + identifier_class);
      }
    },
    view: {
      
    },
  });

  domc.addType('CATEGORY', {
    model: {
      defaults: {
        tagName: 'section',
        components: `<div class="container px-5 py-24 mx-auto"><div class="flex flex-col text-center w-full mb-20"><h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">Master Cleanse Reliac Heirloom</h1><p class="lg:w-2/3 mx-auto leading-relaxed text-base">Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom prism food truck ugh squid celiac humblebrag.</p></div><div class="flex flex-wrap"><div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60"><h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Shooting Stars</h2><p class="leading-relaxed text-base mb-4">Fingerstache flexitarian street art 8-bit waistcoat. Distillery hexagon disrupt edison bulbche.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"></path></svg></a></div><div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60"><h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">The Catalyzer</h2><p class="leading-relaxed text-base mb-4">Fingerstache flexitarian street art 8-bit waistcoat. Distillery hexagon disrupt edison bulbche.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"></path></svg></a></div><div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60"><h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Neptune</h2><p class="leading-relaxed text-base mb-4">Fingerstache flexitarian street art 8-bit waistcoat. Distillery hexagon disrupt edison bulbche.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"></path></svg></a></div><div class="xl:w-1/4 lg:w-1/2 md:w-full px-8 py-6 border-l-2 border-gray-200 border-opacity-60"><h2 class="text-lg sm:text-xl text-gray-900 font-medium title-font mb-2">Melanchole</h2><p class="leading-relaxed text-base mb-4">Fingerstache flexitarian street art 8-bit waistcoat. Distillery hexagon disrupt edison bulbche.</p><a class="text-indigo-500 inline-flex items-center">Learn More<svg fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" class="w-4 h-4 ml-2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"></path></svg></a></div></div><button class="flex mx-auto mt-16 text-white bg-indigo-500 border-0 py-2 px-8 focus:outline-none hover:bg-indigo-600 rounded text-lg">Button</button></div>`,
        traits: [
          {
            type: "select",
            name: "category",
            label: "Category",
            changeProp: 1,
            options: [
            ]
          },
          {
            type: "number",
            name: "number_of_posts",
            label: "Number Of Posts",
            changeProp: 1
          },
        ]
      },
      init() {
        fetch('/admin/categories.json')
        .then(response => response.json())
        .then(options => {
          const categoryTrait = this.getTrait('category');
          
          if(categoryTrait) {
            categoryTrait.set('options', options)
          }

        })
        this.on("change:category", this.handleCategoryChange);
        this.handleCategoryChange();

      },
      handleCategoryChange() {
        const selectedCategory = this.get('category');
        const numberTrait = this.get('number_of_posts');

          if (selectedCategory) {
            // Fetch data from API based on selected category
            fetch(`/admin/categories/${selectedCategory}.json?limit=${numberTrait}`)
              .then(response => response.json())
              .then(data => {
                // Update the component's content with the fetched data
                console.log(data.posts)
                let components = `<div class="container px-5 py-24 mx-auto">
                <div class="flex flex-col text-center w-full mb-20">
                  <h1 class="sm:text-3xl text-2xl font-medium title-font mb-4 text-gray-900">${data.category.name}</h1>
                  <p class="lg:w-2/3 mx-auto leading-relaxed text-base">${data.category.desc}</p>
                </div>`
                components += `<div class="flex flex-wrap">`
                for (let i=0;i<data.posts.length;i++) {
                  const post = data.posts[i]
                  components += `<div class="xl:w-1/${numberTrait} lg:w-1/2 md:w-full px-4 py-3 border-l-2 border-gray-200 border-opacity-60">
                    <div class="h-64 overflow-hidden">
                      <img alt="content" class="object-center h-full w-full" src="${post.image}" />
                    </div>
            
                  <h2 class="text-lg sm:text-xl text-gray-900 py-1 font-medium title-font mb-2"><a href="/${post.slug}">${post.title}</a></h2>
                  <p class="leading-relaxed text-center text-base mb-4">${post.expert}</p>
                </div>`
                }
                components += `</div></div>`
                this.set('components',components)
                this.view && this.view.render();
              })
              .catch(error => console.error('Error fetching data:', error));

              
          }
      },
      updateSectionStyles() {
        // const identifier_class = (Math.random() + 1).toString(36).substring(2);
        // this.setClass(heading_style[this.attributes.tagName] + ' techtown_' + identifier_class);
      }
    },
    view: {
      render() {
        // Implement your view rendering logic here
        console.log('View rendered');
        return this;
      },
    },
  });


};
